import { useMemo } from "react";
import cn from "classnames";
import ChevronDown from "@assets/icons/outline/chevron-down.svg?react";
import Dropdown, { DropdownValueProps, DropdownOptionProps } from "@components/Dropdown";
import { getCountryCallingCode, Country } from "react-phone-number-input/input";
import styles from "./CountrySelect.module.scss";

interface CountryType {
  value?: Country,
  label?: string,
}

interface CountrySelectProps {
  value?: string;
  name?: string;
  onChange: (value?: string) => void;
  onFocus: () => void;
  onBlur: () => void;
  options: CountryType[];
  iconComponent: (props: { country?: string }) => React.ReactNode;
  disabled?: boolean;
  readOnly?: boolean;
  tabIndex?: number | string;
  className: string;
}

const CountrySelect = (props: CountrySelectProps) => {
  const Flag = props.iconComponent;
  const options = useMemo(() => {
    return props.options.map(v => ({ id: v.value ?? "", value: v }));
  }, [props.options]);

  const handleSelect = (id: string) => {
    props.onChange(id);
  };

  const OptionComponent = ({ id, value, isActive }: DropdownOptionProps<string, CountryType>) => {
    if (!id) return (
      <div
        className={styles.separator}
        onClick={(e: any) => {
          e.stopPropagation();
        }}
      />
    )
    // @ts-ignore
    const code = getCountryCallingCode(id);
    return (
      <div className={cn(styles.item, isActive && styles.itemActive)}>
        <Flag country={id} />
        +{code}
        <span>{value?.label}</span>
      </div>
    )
  }

  const ValueComponent = ({ id }: DropdownValueProps<string, CountryType>) => (
    <div className={styles.selected}>
      <Flag country={id} />
      <ChevronDown className={styles.chevron} />
    </div>
  )

  if (options.length === 1) {
    return (
      <div className={styles.selectedSingle}>
        <Flag country={options[0].id} />
      </div>
    )
  }

  return (
    <Dropdown<string, CountryType>
      className={styles.countrySelect}
      onChange={handleSelect}
      OptionComponent={OptionComponent}
      ValueComponent={ValueComponent}
      defaultOption={{ id: props.value ?? "" }}
      options={options}
      menuPosition={"bottom"}
      menuWidth="240px"
      menuAlign="left"
    />
  );
};

export default CountrySelect;
